import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContentText,
  Button,
  DialogContent,
} from '@mui/material'
import { fontSizes } from '../Typography/TypographyStyles'

interface ConfirmationDialogProps {
  open: boolean
  title?: string
  text?: string
  confirmButtonText?: string
  cancelButtonText?: string
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title = 'Are you sure?',
  text = "You won't be able to revert this!",
  confirmButtonText = 'YES',
  cancelButtonText = 'NO',
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby='confirmation-dialog-title'
      aria-describedby='confirmation-dialog-description'
    >
      <DialogTitle
        id='confirmation-dialog-title'
        sx={{ fontWeight: 'bold', fontSize: fontSizes.size20 }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='confirmation-dialog-description' sx={{ fontSize: fontSizes.size14 }}>
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onCancel}>
          {cancelButtonText}
        </Button>
        <Button onClick={onConfirm} autoFocus>
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog
